<template>
  <v-container fill-height fluid pl-0 pr-0 align-start>
    <v-layout column>
      <v-container class="l-container">
        <div class="l-row">
          <v-card id="high-low">
            <v-card-title class="headline">
              <span class="primary--text" v-html="$t('LBL.PRIVACY')"></span>
            </v-card-title>
            <v-card-text>
              <p v-html="$t('TXT.PRIVACY_PAGE_PRIVACY_STATEMENT_HTML')"></p>
              <hr class="mb-3">
              <p v-html="$t('TXT.PRIVACY_PAGE_TERMS_OF_USE_HTML')"></p>
              <hr class="mb-3">
              <p v-html="$t('TXT.PRIVACY_PAGE_EMAIL_HTML')"></p>
              <hr class="mb-3">
              <p v-html="$t('TXT.PRIVACY_PAGE_DATA_USE_AND_ANONY_HTML')"></p>
              <hr class="mb-3">
            </v-card-text>
          </v-card>
        </div>

      </v-container>
    </v-layout>

    <bottom-toolbar v-if="!userObject"></bottom-toolbar>
  </v-container>
</template>

<script>
import BottomToolbar from '@/components/elements/BottomToolbar'
import { mapState } from 'vuex'

export default {
  name: 'PrivacyPage',
  components: {
    'bottom-toolbar': BottomToolbar
  },
  computed: {
    ...mapState([
      'userObject'
    ])
  },
  created () {
    this.$store.commit('UPDATE_APP_STEP', 3)
  }
}
</script>

<style lang="scss" scoped>
@import 'src/styles/_colors';

.card__title {
  text-transform: uppercase;
}
</style>



// WEBPACK FOOTER //
// src/components/pages/PrivacyPage.vue